import { computePosition, flip, type FloatingElement, hide, shift } from "@floating-ui/react"
import { Editor } from "@tiptap/core"
import { posToDOMRect } from "@tiptap/react"

export const updatePosition = (editor: Editor, element: FloatingElement) => {
	const virtualElement = {
		getBoundingClientRect: () => posToDOMRect(editor.view, editor.state.selection.from, editor.state.selection.to),
	}

	void computePosition(virtualElement, element, {
		placement: "bottom-start",
		strategy: "absolute",
		middleware: [shift(), flip(), hide()],
	}).then(({ x, y, strategy }) => {
		element.style.width = "max-content"
		element.style.position = strategy
		element.style.left = `${x}px`
		element.style.top = `${y}px`
	})
}
